export enum FEEDBACK_TYPE {
  GENERIC = 'generic-feedback',
  REPORT_AN_ISSUE = 'report-an-issue',
}

export interface FeedbackFormData {
  feedbackType: FEEDBACK_TYPE;
  shortDescription?: string;
  description: string;
  modelUid?: string;
  attachments?: Array<File>;
  issueType?: string;
  client?: string;
  applicationExperience?: string;
  userName: string;
}

export interface FeedbackFormMailOptions {
  from: string;
  to: string;
  subject: string;
  html: string;
  text?: string;
  attachments?: Array<{
    filename: string;
    content: Buffer;
    contentType?: string;
    cid?: string;
  }>;
}
